import {ExtraReducer, ReducerFromState} from "../../../@types/reducers";

export const getExtrasLength = (state: ReducerFromState<ExtraReducer>): number => state.extra.extras.length;
